export default "__VITE_ASSET__CUfwhD3D__"